import * as React from "react";
import { connect } from "react-redux";

import i18n from "../../lib/i18n";
import { RootState } from "../../state";
import { companySelector, companyMembershipSectionsSelector, draftFeaturedMembershipsSelector } from "../selectors";
import Translate from "../../common/components/Translate";
import { NavigatableSection, SectionInner, SectionTitle, SectionLink } from "./Section";
import { navFullPath } from "./HeaderNav";
import MembershipTeamList from "./MembershipTeamList";
import CompanyMembershipFeaturingsViewer from "../../company_memberships/components/CompanyMembershipFeaturingsViewer";

interface OwnProps {
  locale: string;
  editable?: boolean;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const MembersSectionContainer: React.SFC<Props> = props => {
  const { company, featuredMemberships, membershipSections, locale, editable } = props;

  return (
    <NavigatableSection id="members" displayName={i18n.translate("company.home.sections.members", { locale })}>
      <SectionInner>
        <SectionTitle>
          <Translate id="company.home.sections.members" />
          <SectionLink to={navFullPath(company, "/members")}>
            {editable ? (
              <Translate id="company.home.manage_members" />
            ) : (
              <Translate id="company.home.view_other_members" />
            )}
          </SectionLink>
        </SectionTitle>
        <CompanyMembershipFeaturingsViewer company={company} featuredMemberships={featuredMemberships} />
      </SectionInner>
      <MembershipTeamList
        company={company}
        // TODO:(kdnk): Remove any
        membershipSections={membershipSections as any}
        editable={editable}
        locale={locale}
      />
    </NavigatableSection>
  );
};

function mapStateToProps(state: RootState) {
  return {
    company: companySelector(state)!,
    featuredMemberships: draftFeaturedMembershipsSelector(state),
    membershipSections: companyMembershipSectionsSelector(state),
  };
}

export default connect(mapStateToProps)(MembersSectionContainer);



// WEBPACK FOOTER //
// ./frontend/src/companies/components/MembersSectionContainer.tsx